import React, { useContext, useState } from 'react';
import { AuthenticationContext } from '../../components/AuthenticationContext';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';
import { useQuery } from '@apollo/client';
import { GQL_GET_CAMERA_GOTO } from '../../graphql/queries/cameras';

export default function GoToCamera({ id, open, onClose }: { id: string; open: boolean; onClose: any }) {
  const { removeToken } = useContext(AuthenticationContext);
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState<any>();
  useQuery(GQL_GET_CAMERA_GOTO, {
    onError(error) {
      if (error.graphQLErrors.findIndex((err) => err?.extensions?.code == 'UNAUTHENTICATED') != -1) {
        removeToken();
      } else {
        console.error(error);
      }
      setLoading(false);
    },
    onCompleted(data) {
      setInfo(data.camera);
      setLoading(false);
    },
    variables: {
      cameraId: id,
    },
    skip: !loading || !!info || !id,
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Go to camera</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{loading && 'Loading'}</DialogContentText>
          {info && !loading && (
            <Grid container spacing={2}>
              <Grid item container spacing={2}>
                <Grid item>
                  <b>HTTP URL:</b>
                </Grid>
                <Grid item>
                  <a href={info?.url} target="blank">
                    {info?.url}
                  </a>
                </Grid>
              </Grid>
              {/* <Grid item container spacing={2}>
                <Grid item>
                  <b>RTSP URL:</b>
                </Grid>
                <Grid item>
                  <a href={info?.rtspUrl} target="blank">
                    {info?.rtspUrl}
                  </a>
                </Grid>
              </Grid> */}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
